<template lang="pug">
.whole-container
  transition(name="fade")
    Loading(v-show="loading")
  Header(v-show="!loading")
  Page(v-show="!loading")
</template>

<script>
import Header from './components/Header.vue'
import Page from './components/Page.vue'
import Loading from './components/Loading.vue'

export default {
  name: 'App',
  data() {
    return {
      loading: true
    }
  },
  components: {
    Header,
    Page,
    Loading
  },
  mounted() {
    setTimeout(() => {
      this.loading = false;
    }, 1000);
  }
}
</script>

<style lang="stylus">
*::selection
  background-color sub-color
  color white

html
  scroll-behavior smooth
  -webkit-font-smoothing antialiased
  -moz-osx-font-smoothing grayscale

body
  background-color bg-color
  color text-color !important
  font-family 'Lato', 'Helvetica Neue', Helvetica, Arial, sans-serif
  &::-webkit-scrollbar
    display none

.whole-container
  background-color bg2-color

.fade-enter-active, .fade-leave-active 
  transition opacity .4s cubic-bezier(.22,.68,0,1.71)

.fade-enter, .fade-leave-to
  opacity 0

// video player settings
.plyr--full-ui input[type=range]
  color middle-color

.plyr__control--overlaid
  background middle-color

.plyr--video .plyr__control.plyr__tab-focus, .plyr--video .plyr__control:hover, .plyr--video .plyr__control[aria-expanded=true]
  background middle-color

+tb()
  .gallery .container .my-gallery
    width calc(100vw - 48px)
    display flex
    flex-wrap wrap
    center-align()
    figure
      margin 8px
      width 28vmin
      height 28vmin
+sp()
  .gallery .container .my-gallery
    width calc(100vw - 32px)
    figure
      margin 4px
      width 28vmin
      height 28vmin
</style>